<template>
  <div class="login-form" v-loading="loading">
    <div class="loginText">Log In</div>
    <el-alert
      class="errorMessage"
      :title="error"
      type="error"
      v-show="error"
      :closable="false">
    </el-alert>
    <div class="inputLabel">Email</div>
    <el-input v-model="email" class="email" @keyup.enter.native="login"></el-input>
    <div class="inputLabel">Password</div>
    <el-input type="password" v-model="password" class="password" @keyup.enter.native="login"></el-input>
    <el-button type="primary" @click="login()" class="loginButton">Log In</el-button>
    <div class="footer" style="font-size: 10px">
      <router-link :to="{ name: 'forgot-password' }">Forgot password?</router-link><br>
      <a href="https://www.nativo.com/privacy-policy" target="_blank">
        Privacy Policy
      </a>
    </div>
  </div>
</template>

<script>
  import ApiClient from '@/components/api-client'

  export default {
    name: 'login',
    data () {
      return {
        email: null,
        password: null,
        error: '',
        loading: false
      }
    },
    methods: {
      login () {
        this.error = ''
        this.loading = true
        ApiClient.login(this.email, this.password)
          .then(
            () => {
              this.loading = false
              if (this.$route.query.n !== undefined) {
                const to = new URL(decodeURIComponent(this.$route.query.n), window.location)
                if (to.origin !== window.location.origin) {
                  this.$router.push({name: 'home'})
                } else {
                  this.$router.push({path: to.pathname})
                }
              } else {
                this.$router.push({name: 'home'})
              }
            }
          ).catch(
          error => {
            this.loading = false
            if (error.response.data.detail !== undefined) {
              this.error = error.response.data.detail
            } else if (error.response.data.nonFieldErrors !== undefined) {
              this.error = error.response.data.nonFieldErrors[0]
            }
          })
      }
    }
  }
</script>

<style scoped lang="less">
  .login {
    height: 100%;
    margin-top: -21px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .login::after {
    content: "";
    background-image: url("../../../assets/images/clouds.jpg");
    background-size: 3000px;
    background-position: -300px -300px;
    opacity: 0.4;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
  }

  .nativoLogo {
    width: 213px;
    padding-bottom: 40px;
  }

  .errorMessage {
    margin-bottom: 10px;
  }

  .login-form {
    box-sizing: border-box;
    width: 420px;
    padding: 25px 30px 25px 30px;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.14);

    .loginText {
      font-size: 35px;
      font-weight: 300;
      color: #898989;
      padding-bottom: 25px;
    }

    .forgotPassword {
      color: #b9b9b9;
      font-size: 12px;
      text-align: right;
      width: 100%;
      float: right;
      margin-bottom: 20px;
    }

    .inputLabel {
      font-size: 12px;
      margin-bottom: 4px;
      margin-left: 1px;
    }
    .email {
      padding-bottom: 20px;
    }

    .password {
      padding-bottom: 5px;
    }

    .loginButton {
      margin-top: 45px;
      width: 100%;
    }
  }

  .footer {
    margin-top: 30px;
    text-align: center;
  }
</style>
